import { Link } from 'react-router-dom';
import { ArrowUpRight, MessageCircle, LogIn } from 'lucide-react';
import { LANDING_ANCHORS } from '../../domain/landingContent';

const TRANS = 'transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)]';

interface WidthProp {
  width?: 'full' | 'auto';
}

function widthClass(width: 'full' | 'auto') {
  return width === 'full' ? 'w-full sm:w-auto' : '';
}

/** CTA primário — pedir demonstração (scroll para formulário). */
export function DemoCta({ width = 'auto' }: WidthProp) {
  return (
    <a
      href={`#${LANDING_ANCHORS.contato}`}
      className={`group ${widthClass(width)} ${TRANS} inline-flex min-h-12 items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-orange-500 to-rose-500 py-1.5 pl-6 pr-1.5 text-sm font-semibold text-white shadow-lg shadow-orange-600/25 hover:shadow-orange-500/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/50 active:scale-[0.98] motion-reduce:transition-none`}
    >
      Pedir demonstração
      <span
        className={`${TRANS} flex h-8 w-8 items-center justify-center rounded-full bg-white/15 group-hover:translate-x-0.5 group-hover:-translate-y-px group-hover:scale-105`}
      >
        <ArrowUpRight className="h-4 w-4" />
      </span>
    </a>
  );
}

/** CTA secundário — WhatsApp. */
export function WhatsAppCta({ whatsappUrl, width = 'auto' }: WidthProp & { whatsappUrl: string }) {
  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`group ${widthClass(width)} ${TRANS} inline-flex min-h-12 items-center justify-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-6 text-sm font-semibold text-slate-200 hover:border-white/20 hover:bg-white/[0.08] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20 active:scale-[0.98]`}
    >
      <MessageCircle className={`${TRANS} h-4 w-4 text-emerald-400 group-hover:scale-110`} />
      Falar no WhatsApp
    </a>
  );
}

/** CTA terciário — login para clientes existentes. */
export function LoginCta({ loginPath, width = 'auto' }: WidthProp & { loginPath: string }) {
  return (
    <Link
      to={loginPath}
      className={`group ${widthClass(width)} ${TRANS} inline-flex min-h-11 items-center justify-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-5 text-xs font-semibold text-white hover:border-white/20 hover:bg-white/[0.08] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20 active:scale-[0.98] sm:min-h-12 sm:text-sm`}
    >
      <LogIn className="h-4 w-4 text-slate-400 group-hover:text-white" />
      Já sou cliente
    </Link>
  );
}

